<template>
    <div>
        <!-- <Head>
            <template v-slot:title>
                <span style="margin-left:30%;margin-right:39px;" :class="{'title-link':true,'avtive':info=='1'}" @click="myInfo('1')">我的资料</span>
                <span :class="{'title-link':true,'avtive':info=='2'}" @click="myInfo('2')">公司主页</span>
            </template>
       </Head> -->
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="15">
                <el-card class="box-card card">
                <!-- 我的资料主页 -->
                    <div v-if="jbInfo">            
                        <el-row>
                            <el-col :span="24">
                                <div class="grid-content bg-purple-dark info-box">
                                    <el-row type="flex" class="row-bg">
                                        <el-col :span="19">
                                            <span class="title">基本信息</span>
                                        </el-col>
                                        <el-col :span="5">
                                            <span class="compile" @click="jbInfo=false">编辑</span>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                            <div class="grid-content bg-purple-dark form">
                                <el-form :label-position="labelPosition" label-width="80px">
                                    <el-row type="flex" class="row-bg">
                                        <el-col :span="18">
                                            <el-col :span="11">
                                                <el-form-item label="姓名">
                                                   {{name}}
                                                </el-form-item>
                                            </el-col>
                                        </el-col>
                                        <el-col :span="6" class="userImag" style="padding-left:2.3333%;margin-top:20px;">
                                            <el-avatar :size="68" :src="headPortrait || defaultLogo"></el-avatar>
                                        </el-col>
                                    </el-row>
                                        
                                        <el-col :span="18">
                                            <el-col :span="11">
                                                <el-form-item label="职位">
                                                    {{positionName}}
                                                </el-form-item>
                                            </el-col>
                                        </el-col>
                                        
                                        
                                    </el-form>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                <!-- 我的资料更改资料 -->               
                    <div v-else>  
                        <div style="background-color:#E6ECF8;">          
                            <el-row>
                                <el-col :span="24">
                                    <div class="grid-content bg-purple-dark info-box">
                                        <el-row type="flex" class="row-bg">
                                            <el-col :span="19">
                                                <span class="title">基本信息</span>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="24">
                                    <div class="grid-content bg-purple-dark form">
                                        <el-form :label-position="labelPosition" label-width="80px">
                                                
                                            <el-row type="flex" class="row-bg">
                                                <el-col :span="8">
                                                    <el-form-item label="职位">
                                                        <el-input
                                                            v-model="positionName"
                                                            >
                                                        </el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>

                                            <el-row type="flex" class="row-bg">
                                                <el-col :span="8">
                                                   <el-form-item label="头像">
                                                       <el-upload
                                                            class="avatar-uploader headPortrait-img"
                                                            action="https://upload.xuruidea.com/uploadFile?type=1"
                                                            :show-file-list="false"
                                                            :on-success="handleAvatarSuccess"
                                                            >
                                                            <img v-if="headPortrait" :src="headPortrait" class="avatar">
                                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                        </el-upload>
                                                   </el-form-item>
                                                </el-col>
                                            </el-row>
                                                
                                            <el-row type="flex" class="row-bg" justify="center" style="margin-bottom:50px;">
                                                <el-col :span="10" style="text-align:center;">
                                                        <el-button class="cancel" @click="jbInfo=true">取消</el-button>
                                                        <el-button class="save" type="primary theme-btn" @click="saveInfo">保存</el-button>
                                                </el-col>
                                            </el-row>
                                        </el-form>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                    <div class="form">
                        <el-row type="flex" class="row-bg" >
                            <el-col class="bottom-box">
                                <el-form :label-position="labelPosition" label-width="80px">
                                   
                                    <el-form-item label="联系方式">
                                        <el-input v-model="phone" class="inp text-bg" :disabled="!relationFs"></el-input>
                                    </el-form-item>
                                    <el-row v-if="relationFs" class="codeBox" >
                                        <el-col>
                                            <el-input v-model="code" class="inp text-bg code-inp"></el-input>
                                            <span ref="code" class="get-code-btn" @click="getCode">获取验证码</span>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </el-col>
                    
                            <!-- 联系方式编辑保存 -->
                            <el-col :span="10" style="text-align:right;" v-if="!relationFs">
                                <span class="compile" @click="relationFs=true">修改</span>
                            </el-col>
                        </el-row>
                        <el-row type="flex" justify="center" v-if="relationFs">
                            <el-col :span="10" style="text-align:center;">
                                <el-button class="cancel" @click="relationFs=false" >取消</el-button>
                                <el-button class="save" type="primary theme-btn" @click="savePhone">保存</el-button>
                            </el-col>
                        </el-row>
                    </div>



                <el-divider></el-divider>
                    <el-row>
                        <el-col :span="24">
                            <div class="grid-content bg-purple-dark info-box">
                                <el-row type="flex" class="row-bg">
                                    <el-col :span="19">
                                        <span class="title">任职信息</span>
                                    </el-col>
                                    <el-col :span="5">
                                        <span class="compile" @click="isLeave = true">离开公司</span>
                                    </el-col>
                                </el-row>
                                <el-row class="company" style="margin-top:20px;">
                                    <el-col class="companyImgBox">
                                        <el-avatar class="company-logo" shape="square" :size="60" :src="logo"></el-avatar>
                                    </el-col>
                                    <el-col :span="10" class="companytitle">
                                       <span>{{companyName}}</span>|
                                       <span>{{industryName}}</span>
                                       <li>{{simpleName}}</li>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-col>
                    </el-row>
                    
                </el-card>
            </el-col>
        </el-row>

<!-- 离开公司弹框 -->
        <el-dialog 
            width="15%"
            :visible.sync="isLeave"
            :show-close="false"
            class="warning">
            <p class="font">确认离开{{companyName}}</p>
            <p slot="footer" class="dialog-footer">
                <el-button @click="leaveFun(0)" class="refuse">拒 绝</el-button>
                <el-button @click="leaveFun(1)" class="confirm">同 意</el-button>
            </p>
        </el-dialog>

       

       
    </div>
</template>
<script>
import Head from '@/components/header/head.vue'
import {countDwon,alertBox} from '@/utils/methods.js'
export default {
    data(){
        return{
            labelPosition: 'right',
            name:'',    //姓名
            phone:'',   // 手机号码
            code:'',    // 验证码
            email:'',   //email
            positionName:'',    // 职位名称
            defaultLogo:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            headPortrait:'',    // 头像
            logo:'',    // 公司logo
            companyName:'',    // 公司名称
            simpleName:'',  //  任职
            industryName:'',    // 公司性质
            userId:'',

            count:60,


        
            checked:false,
            

            relationFs:false,
            weChat:false,
            jbInfo:true,    // 是否不显示更改用户信息界面
            // info:'1'
    
// 离开公司弹框数据
            companyName:'',
            isLeave:false     // 离开公司
            }
    },
    components:{
        Head
    },
    methods:{
    // 更改头像
        handleAvatarSuccess(res, file) {
            this.headPortrait = file.response.data.url
        },

    // 用户信息保存
        saveInfo(){
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            this.axiosPost(`/userBaseInfo/updateCompany`,
                {
                    positionName:this.positionName,
                    phone:this.phone,
                    userId:userInfo.id,
                    headPortrait:this.headPortrait
                }
            ).then((res)=>{
                this.jbInfo = true;
                // console.log('用户信息')
                // console.log(res)
                if(res.code==200){
                    this.$store.commit('updateUserImg',this.headPortrait)
                }
            })
        },
    // 离开公司弹框拒绝/同意函数
        leaveFun(flag){
            if(flag==1){
                this.axiosPost(`/user/relieveCompanyStatus${this.userId}`).then((res)=>{
                    console.log('离开公司')
                    console.log(res)
                })
            }
            this.isLeave = false
        },
    
    // 获取验证码
        getCode(){
            let code = this.$refs.code
            let userId = JSON.parse(sessionStorage.getItem('userInfo')).id
            // console.log(this.$refs.code)
            
            if(code.innerHTML=="获取验证码"){
                this.axiosPost(`/sendMessages`,
                    {
                        userId:userId,
                        phone:this.phone
                    }
                ).then((res)=>{
                    console.log('获取验证码')
                    console.log(res)
                   
                    if(res.code==500){
                        this.$message({
                            message: res.message,
                            type: 'error',
                            duration:1500
                        });
                        return
                    }else if(res.code==200){
                        this.$message({
                            message: res.message,
                            type: 'success',
                            duration:1500
                        });
                        countDwon(code,this.count)
                       
                    }

                })
            }
        },
        savePhone(){
            this.code = ''
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            this.axiosPost(`/sendMessages/checkCode`,
                {
                    phone:this.phone,
                    userId:userInfo.id,
                    code:this.code
                }
            ).then((res)=>{
                console.log('code')
                console.log(res)
                if(res.code==200){
                    this.relationFs = false
                }
                let status = res.code==200?'success':'error'
                this.$message({
                    message: res.message,
                    type: status,
                    duration:1500
                });
            })
        }
    },
    mounted(){
        let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
        this.axiosGet(`/userBaseInfo/findCompanyById/${userInfo.id}`).then((res)=>{
            // console.log('个人信息')
            // console.log(res)
            if(res.code==200){
                //  name:'',    
                //     phone:'',   // 手机号码
                //     code:'',    // 验证码
                //     email:'',   //email
                //     nickName:'',    // 职位名称
                //     headPortrait:'',    // 头像
                //     companyName:'',
                this.name = res.data.name   //姓名
                this.headPortrait = res.data.headPortrait   // 管理员头像
                this.positionName = res.data.positionName   // 职位名称
                // this.headPortrait = res.data.headPortrait   // 
                this.$store.commit('updateUserImg',res.data.headPortrait)
                this.phone = res.data.phone     // 手机号码

            }
        })

        this.axiosGet(`/company/findById/${userInfo.companyId}`).then((res)=>{
                if(res.code==200){
                    this.companyName = res.data.name    // 公司名称
                    this.simpleName = res.data.simpleName  //  任职
                    this.industryName = res.data.industryName   // 公司性质
                    this.logo = res.data.logo   // 公司logo
                }
        })
    }
}
</script>
<style lang="less" scoped>
    .avatar {
        width: 68px;
        height: 68px;
        display: block;
        border-radius:50%;
    }
    .inp{
        width:80%;
    }
    .bottom-box{
        width:40%;
    }
    .codeBox{
        width:64%;
        margin-left:22%;
        margin-bottom:40px;
        .inp.text-bg{
            width:58%;
            border-top-right-radius:0;
            border-bottom-right-radius:0;
        }
        .get-code-btn{
            display:inline-block;
            width:40%;
            cursor:pointer;
            text-align:center;
            color:#1A80FC;
            border-top-right-radius:4px;
            border-bottom-right-radius:4px;
             padding:0;
            font-size:16px;
            border:none;
            height:40px;
            line-height:40px;
            vertical-align:bottom;
            background-color:#B3D2FB;
            font-weight:500;
        }
        .get-code-btn:hover{
            background:#B3D2FB;
        }
    }
    .num{ 
        font-size: 48px;
        font-weight: 500;
        color: #197FFB;
        line-height: 74px;
        margin-right:10px;
    }
    .info-box{
        padding-left:73px;
    }
    .form{
        padding-left:78px;
    }
    .compile{
        cursor:pointer;     
        font-size: 16px;
        font-weight: 400;
        color: #1A80FC;
        line-height: 30px;

    }
    .title{     
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        line-height: 30px;
        position:relative;
        bottom:5px;
    }

    .company{
        .companyImgBox{
            width:60px;
        }
    }

    .chck{
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
    }
    .el-col-offset-8{
        margin-left:40.3333%
    }
    .btn_fb,
    .row-bg{
        margin-top:20px;
    }
    .companytitle{
        margin-left:10px;
        >span{
            padding:0 10px;    
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
        }
        >li{          
            padding-left:10px;
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            line-height: 30px;
        }
    }
    .cancel{
        margin-right:12%;
        width:25%;
    }
    .cancel.qx{
        margin-right:6%;
    }
    .save{
        width:25%;
    }

// 离开公司弹框
    .warning{
        .font{
            text-align:center;
        }
        .dialog-footer{
            border-top:solid #999999 1px;
            height:50px;
        }
    }
    .refuse,.confirm{
        width:50%;
        height:100%;
        border:none;
        margin-left:0;
        border-radius:0;
    }
    .confirm{
        color:#1A80FC;
    }
   
</style>